import { useStore, useStoreUI } from '@assets/model/Store';
import { observer } from 'mobx-react';
import * as style from './ModalDataLossPrompt.module.less';
import { Flex } from '@assets/component/UI/Flex/Flex';
import { Button } from 'react-bootstrap';
import warning_svg from './warning.svg';

interface ModalDataLossPromptProps {
    onVerifyDelete: () => void;
    labels: {
        approveActionText?: string;
        cancelButtonText?: string;
        bigWarning: string;
        smallWarning: string;
        deleteDataName: string;
    };
}

export const ModalDataLossPrompt = observer(
    (props: ModalDataLossPromptProps) => {
        const ui = useStoreUI();
        const approveStr = props.labels.approveActionText ?? 'Delete';
        const cancelStr = props.labels.cancelButtonText ?? 'Cancel';

        return (
            <>
                <Flex fillCell={true} direction="column" alignItems="start">
                    <Flex
                        direction="column"
                        wrap="wrap"
                        style={{ width: '100%' }}
                        alignItems="center"
                        justify="center"
                    >
                        <div className={style.warning_svg}>
                            <img src={warning_svg} height="100px" />
                        </div>

                        <div className={style.warning_big}>
                            {props.labels.bigWarning}
                        </div>
                        <div className={style.warning_big_target}>
                            {props.labels.deleteDataName}
                        </div>
                        <div className={style.warning_small}>
                            {props.labels.smallWarning}
                        </div>
                    </Flex>

                    <div style={{ flexGrow: 1 }}></div>
                    <div className={style.seperator}></div>
                    <Flex
                        direction="row"
                        style={{
                            width: '100%',
                            height: '40px'
                        }}
                    >
                        <Button
                            onClick={() => {
                                ui.modal = null;
                            }}
                            className={style.cancelButton}
                        >
                            {cancelStr}
                        </Button>
                        <div style={{ flexGrow: 1 }}></div>
                        <Button
                            onClick={() => {
                                props.onVerifyDelete();
                                ui.modal = null;
                            }}
                            className={style.confirmButton}
                        >
                            {approveStr}
                        </Button>
                    </Flex>
                </Flex>
            </>
        );
    }
);
